class TokenWorth {
  constructor(tokenWorthData = {}) {
    this.worth = tokenWorthData.worth || 0;
  }
}

export default TokenWorth;
